import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL;

class SavedSearchesService {
  async get(id) {
    try {
      const { data } = await axios.get(API_URL + `/saved-searches/${id}`);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', data: {} };
        }
        if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        }
      }
      return { status: 'failed', data: {} };
    }
  }

  async list(offset = 0, limit = 50) {
    try {
      const { data } = await axios.get(API_URL + '/saved-searches', {
        params: { offset, limit }
      });
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', data: {} };
        }
      }
      return { status: 'failed', data: {} };
    }
  }

  async create(name, description, query, filters, meta = null) {
    try {
      const payload = { name, description, query, filters }
      if (meta) payload.meta = meta
      const { data } = await axios.post(API_URL + '/saved-searches', payload);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 400) {
          return {
            status: 'error',
            message: error.response.data.message || 'Invalid request'
          };
        }
      }
      return { status: 'failed', message: 'Failed to save search' };
    }
  }

  async update(id, name, description, query, filters) {
    try {
      const { data } = await axios.put(API_URL + `/saved-searches/${id}`, {
        name,
        description,
        query,
        filters
      });
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        } else if (error.response.status === 400) {
          return {
            status: 'error',
            message: error.response.data.message || 'Invalid request'
          };
        }
      }
      return { status: 'failed', message: 'Failed to update search' };
    }
  }

  async delete(id) {
    try {
      const { data } = await axios.delete(API_URL + `/saved-searches/${id}`);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        }
      }
      return { status: 'failed', message: 'Failed to delete search' };
    }
  }

  async subscribe(id) {
    try {
      const { data } = await axios.post(API_URL + `/saved-searches/${id}/subscribe`);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        }
      }
      return { status: 'failed', message: 'Failed to subscribe to search' };
    }
  }

  async unsubscribe(id) {
    try {
      const { data } = await axios.post(API_URL + `/saved-searches/${id}/unsubscribe`);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        }
      }
      return { status: 'failed', message: 'Failed to unsubscribe from search' };
    }
  }

  async checkIn(id) {
    try {
      const { data } = await axios.post(API_URL + `/saved-searches/${id}/checkin`);
      return data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return { status: 'unauthorized', message: 'Unauthorized' };
        } else if (error.response.status === 404) {
          return { status: 'not_found', message: 'Saved search not found' };
        }
      }
      return { status: 'failed', message: 'Failed to check in to search' };
    }
  }
}

export default new SavedSearchesService();
